<template>
  <Layout>
    <div class="content">
      <div class="row mb-3">
        <div class="col-12">
          <div class="fs-20 fw-medium text-body lh-24">
            {{ pageTitle }}
          </div>
          <div class="fs-14 fw-400 text-muted lh-24">
            {{ pageInfo.description }}
          </div>
        </div>
      </div>
      <div class="row" v-for="(info, i) in pageInfo.cardInfo" :key="i">
        <div class="col-12">
          <div class="card">
            <div class="card-header align-items-center d-flex">
              <h4 class="card-title mb-0 flex-grow-1">{{ info.title }}</h4>
            </div>
            <div class="card-body pt-0">
              <div class="fs-13 fw-400 text-muted lh-20 mb-3">
                {{ info.description }}
              </div>
              <component
                :is="info.componentName"
                v-model:parentInfo="parentInfo"
                v-model:baseInfo="baseInfo"
                v-model:attributes="attributes"
                v-model:measurements="measurements"
                v-model:fault_knowledge="fault_knowledge"
                v-model:repairs="repairs"
                v-model:files="files"
                v-model:tags="tags"
                :units="units"
                :dataTypes="dataTypes"
                :validationTips="validationTips"
                :equipStatus="equipStatus"
                :equipDisciplineClass="equipDisciplineClass"
                :submitted="submitted"
                @handleSubmitted="submitted = false"
                @handleAlert="handleAlert"
                @getCustomerid="getCustomerid"
              >
              </component>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <div class="text-end">
            <b-button
              variant="outline-dark"
              size="md"
              class="waves-effect waves-light me-4"
              @click="handelCancel"
              style="min-width: 6rem"
              >{{ $t('Cancel') }}</b-button
            >
            <b-button
              variant="primary"
              size="md"
              class="btn btn-primary"
              @click="handleSubmit"
              style="min-width: 6rem"
              :disabled="submitLoading"
            >
              <b-spinner
                variant="light"
                style="width: 1rem; height: 1rem"
                v-show="submitLoading"
              ></b-spinner>
              <span v-show="!submitLoading">{{
                $route.query.type === "edit"
                  ? this.$t("base.save")
                  : this.$t("page.product-library.CreateProduct")
              }}</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import MessageAlert from "@/components/common/MessageAlert";
import ParentInfo from "./parentInfo.vue";
import BaseInfo from "./baseInfo.vue";
import Attribute from "./attribute.vue";
import MeasureValue from "./measureValue.vue";
import Repair from "./repair.vue";
// 资料库
import Database from "./database.vue";
import Tag from "./tag.vue";
import FaultknowledgeBase from "./FaultknowledgeBase.vue";
import appConfig from "../../../../app.config";
import _ from "loadsh";
import Swal from "sweetalert2";
import { createModel, putModel, getModelDetailId  } from "@/service/index";
import { randomColor } from "@/utils/common.js";
import {
  pageInfo,
  dataTypes,
  equipStatus,
  equipDisciplineClass,
  units,
  attributes,
  validationTips,
} from "@/utils/selectText.js";
import moment from "moment";
import i18n from "@/i18n";
import EquipmentDatabase from "@/views/asset/form/equipmentDatabase.vue";
export default {
  page: {
    title: i18n.global.t("base.product"),
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {

      title: "",
      items: [
        {
          text: this.$t("page.product-library.ProductManagement"),
        },
        {
          text: this.$t("menu.equipment-management.model-management.model"),
          active: true,
          href: "/model",
        },
        {
          text: this.$route.query.title,
          active: true,
        },
      ],
      pageTitle: this.$route.query.title,
      pageInfo,
      dataTypes,
      units,
      equipStatus,
      equipDisciplineClass,
      validationTips,
      dataValidation: {
        type: true,
        typeError: this.$t("page.must_be_integer"),
      },
      alertInfo: {
        variant: "danger",
        content: this.$t("page.form_verification_failed"),
        icon: "ri-error-warning-line",
      },
      parentInfo: {},
      baseInfo: {
        name: "",
        description: "",
        is_import_pump: "0",
        is_iot_ready: "0",
      },
      attributes: [],
      measurements: [],
      fault_knowledge: [],
      repairs: [],
      files: { image: [], video: [], document: [],'3d':[] },
      tags: [],
      submitLoading: false,
      submitted: false,
      formValidataAlert: false,
      parent_id: "",
      btnType: "add",
      customer_id: "",
      service_company_id: "",

    };
  },
  components: {
    EquipmentDatabase,
    Layout,
    MessageAlert,
    ParentInfo,
    BaseInfo,
    Attribute,
    MeasureValue,
    Repair,
    Database,
    Tag,
    FaultknowledgeBase,
  },
  watch: {
    $route: {
      handler() {
        if (_.get(this.$route, ["query", "type"]) == "edit") {
          this.btnType = "edit";
          this.pageTitle = this.$t("page.product-library.EditProduct");
        } else {
          this.pageTitle = this.$t("page.product-library.NewProduct");
          this.attributes = _.cloneDeep(attributes);
          console.log("this.attributes",attributes);
          
        }

        let modelId = _.get(this.$route, ["query", "model_id"]);
        if (modelId) {
          this.getModelDetail(modelId);
        }
        this.parentInfo = _.get(this.$route, ["query", "model_id"]);
      },
      deep: true,
      immediate: true,
    },
    parentInfo: {
      handler(val) {
        if (this.btnType !== "edit" && val) {
          // 新建时，选择父级模型，自动填充父级模型的属性
          if (
            val.node &&
            val.node.length > 0 &&
            val.node[val.node.length - 1]
          ) {
            this.getModelDetail(val.node[val.node.length - 1]);

          } else {
            this.attributes = _.cloneDeep(attributes);
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log("1");
  },
  methods: {
    getCustomerid(data) {
      console.log(data);
      this.customer_id = data.customer_id;
      this.service_company_id = data.service_company_id;
    },
    handleData(key, data) {
      this[key] = data;
    },
    /* 按钮-取消事件 */
    handelCancel() {
      let modelId = _.get(this.$route, ["query", "model_id"]);
      if (modelId) {
        this.$router.push({
          path: "/model",
        });
      } else {
        this.$router.go(-1);
      }
    },
    /* 获取单个产品详情 */
    getModelDetail(id) {
      getModelDetailId({ id })
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
            let attrDataList = [];
            if (res.payload.attributes && res.payload.attributes.attributes) {
              if (res.payload.attributes.attributes[0].group) {
                attrDataList = this.filterGroupAttr(
                  res.payload.attributes.attributes
                );
              } else {
                attrDataList = [
                  ..._.cloneDeep(attributes),
                  {
                    group: this.$t("page.product-library.OtherInformation"),
                    list: [...res.payload.attributes.attributes],
                  },
                ];
              }
            }
            if (this.btnType == "edit") {
              this.baseInfo = {
                name: _.get(res, ["payload", "name"]),
                description: _.get(res, ["payload", "description"]),
                is_import_pump: _.get(res, ["payload", "is_import_pump"]),
                is_iot_ready: _.get(res, ["payload", "is_iot_ready"]),
              };
              let parent_id = _.get(res, ["payload", "parent_id"]);
              if (!parent_id) {
                this.parentInfo.node = [parent_id];
              } else {
                this.parentInfo.node = parent_id;
              }
            } else {
              this.baseInfo = {
                name: "",
                description: "",
                is_import_pump: _.get(res, ["payload", "is_import_pump"]),
                is_iot_ready: _.get(res, ["payload", "is_iot_ready"]),
              };
            }

            this.attributes = attrDataList;
            console.log("属性", this.attributes);
            this.attributes.forEach((attr) => {
              if (attr.list && attr.list.length > 0) {
                attr.list.forEach((l) => {
                  if (
                    this.$route.query.title ==
                    this.$t("page.product-library.NewProduct")
                  ) {
                    l["owner"] = "inherit";
                  }
                  if (this.btnType != "edit") {
                    l.disabled = true;
                  } else {
                    l.disabled = false;
                  }
                });
              }
            });
            this.measurements = _.get(res, [
              "payload",
              "attributes",
              "measurements",
            ]);
            if (this.measurements.length) {
              this.measurements.forEach((item, i) => {
                if (
                  this.$route.query.title ==
                  this.$t("page.product-library.NewProduct")
                ) {
                  item["owner"] = "inherit";
                }
                if (this.btnType != "edit") {
                  item.disabled = true;
                } else {
                  item.disabled = false;
                }
                if (!item.key) {
                  item.key = `measure${i}` + new Date().getTime();
                }
              });
            }
            console.log("测点", this.measurements);
            this.files = _.get(res, ["payload", "files"]);
            if(this.btnType != "edit"){

              //需要继承父级file的文件设置为继承属性，relation_type: inherit继承/self非继承*/
              for(let obj in this.files){
                if(this.files[obj].length){
                  this.files[obj].forEach(item=>{
                    item.relation_type = 'inherit'
                  })
                }
              }
            }

            Object.values(this.files).forEach((file) => {
              if (file.length > 0) {
                file.forEach((item) => {
                  if (this.btnType != "edit") {
                    item.disabled = true;
                  } else {
                    if (item.relation_type == 'inherit') {
                      item.disabled = true;
                    }
                    else {
                      item.disabled = false;
                    }
                  }
                });
              }
            });
            this.repairs = _.get(res, ["payload", "repairs"]) || [];
            if (this.repairs.length) {
              this.repairs.forEach((item) => {
                if (this.btnType != "edit") {
                  item.disabled = true;
                } else if (item.relation_type == "inherit") {
                  item.disabled = true;
                } else {
                  item.disabled = false;
                }
              });
            }
            console.log("维护", this.repairs);
            this.fault_knowledge =
              _.get(res, ["payload", "fault_knowledge"]) || [];
             this.fault_knowledge.map(item=>{
                 if (
                  this.$route.query.title ==
                  this.$t("page.product-library.NewProduct")
                ) {
                  item["relation_type"] = "inherit";
                }
                 item.nameType=false
                 item.is_deleted=false
                 item.description.map(a=>{
                     a.is_deleted=false
                 })
             })
            this.tags = _.get(res, ["payload", "tags"]) || [];
            if (this.tags.length) {
              this.tags.forEach((item) => {
                if (this.btnType != "edit") {
                  item.disabled = true;
                } else {
                  item.disabled = false;
                }
              });
            }
            this.handleUnits();
          } else {
            this.handleAlert(
              this.$t("page.product-library.RequestFailedPleaseTryAgain")
            );
          }
        })
        .catch((err) => {
          err.error && this.handleAlert("danger", err.error);
        });
    },
    /* 单位数据集合初始化 */
    handleUnits() {
      var defaultUnits = [
        this.$t("page.no"),
        "℃",
        "A",
        "V",
        "kW",
        "m²",
        "m³",
        "mg/m³",
      ];
      this.attributes.forEach((Item) => {
        Item.list.forEach((item) => {
          if (item.unit == "") {
            item.unit = this.$t("page.no");
          }
          if (!defaultUnits.includes(item.unit)) {
            defaultUnits.push(item.unit);
          }
        });
      });
      this.units = defaultUnits;
    },
    filterGroupAttr(arr) {
      var map = {},
        dest = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.group]) {
          dest.push({
            group: ai.group,
            list: [ai],
          });
          map[ai.group] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.group == ai.group) {
              dj.list.push(ai);
              break;
            }
          }
        }
      }
      return dest;
    },
    filterAttribute(data) {
      let result = [];
      data.forEach((Item) => {
        var group = Item.group;
        Item.list.forEach((item) => {
          result.push({ ...item, group });
        });
      });
      return result;
    },
    delIsUploaded(list){
      list.forEach(item=>{
        if(item.is_uploaded) {
          delete item.is_uploaded
        }
      })
    },
    /* 按钮-提交事件 */
    handleSubmit() {
      this.submitted = true;
      if (!this.handleCheckSubmitData()) {
        this.handleAlert();
        return;
      }
      Swal.fire({
        title: this.$t("page.submitting"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      this.submitLoading = true;
      let modelId = _.get(this.$route, ["query", "model_id"]);
      let type = _.get(this.$route, ["query", "type"]);
      let params = this.handleFilterSubmitData();
      if (type == "edit") {
        // 编辑产品
        putModel(modelId, params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
              this.handleAlert(
                "success",
                this.$t(
                  "page.product-library.SavedSuccessfullyWillJumpDetailsPage"
                ),
                "ri-check-double-line",
                1000
              );
              Swal.close();
              setTimeout(() => {
                this.$router.push({
                  path: "/model",
                  query: { model_id: modelId },
                });
                this.submitLoading = false;
              }, 1000);
            }
          })
          .catch((err) => {
            Swal.close();
            if (err.error && err.error == "name already exists") {
              this.handleAlert(
                "danger",
                `${this.$t("page.product-library.ProductNameHasBeenRepeated")}!`
              );
            } else {
              this.handleAlert(
                "danger",
                err.error ||
                  `${this.$t(
                    "page.product-library.RequestFailedPleaseTryAgain"
                  )}!`
              );
            }
            this.submitLoading = false;
          });
      } else {
        // 创建产品(在parentInfo里面可以修改type，所以这里不用再判断type)
        // params.product_type = _.get(this.$route, ["query", "current_type"]);
        createModel(params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
              this.handleAlert(
                "success",
                this.$t(
                  "page.product-library.CreationSuccessfulWillJumpProductPage"
                ),
                "ri-check-double-line",
                1000
              );
              Swal.close();
              setTimeout(() => {
                this.$router.push({
                  path: "/model",
                });
                this.submitLoading = false;
              }, 1000);
            }
          })
          .catch((err) => {
            this.submitLoading = false;
            if (err.error && err.error == "name already exists") {
              this.handleAlert(
                "danger",
                `${this.$t("page.product-library.ProductNameHasBeenRepeated")}!`
              );
            } else {
              this.handleAlert(
                "danger",
                err.error ||
                  `${this.$t(
                    "page.product-library.RequestFailedPleaseTryAgain"
                  )}!`
              );
            }
            Swal.close();
          });
      }
    },
    isNumber(val) {
      return !isNaN(val);
    },
    isRepeat(arr, key) {
      let names = arr.map((item) => item[key]);
      let nameSet = new Set(names);
      return nameSet.size == names.length;
    },
    /* 表单校验 */
    handleCheckSubmitData() {
      let checkResult = false;
      let checkList = [false, false, false, false];
      let parentInfo = this.parentInfo;
      let baseInfo = this.baseInfo;
      let attributes = {
        attributes: this.attributes,
        measurements: this.measurements,
      };
      let attrData = this.filterAttribute(this.attributes);

      // 维护保养定义表单检测
      checkList[3] = true;
      if (this.repairs.length) {
        for (let i = 0; i < this.repairs.length; i++) {
          if (this.repairs[i].is_deleted) continue;
          if (this.repairs[i].item_name) {
            if (this.repairs[i].item_name.length > 50) {
              this.alertInfo.content = this.$t(
                "page.maintenance_item_name_cannot_exceed"
              );
              checkList[3] = false;
              break;
            } else {
              if (i == this.repairs.length - 1) checkList[3] = true;
            }
          } else {
            this.alertInfo.content = this.$t(
              "page.maintenance_item_name_cannot_empty"
            );
            checkList[3] = false;
            break;
          }
          if (!this.repairs[i].name) {
            this.alertInfo.content = this.$t(
              "page.maintenance_name_cannot_empty"
            );
            checkList[3] = false;
            break;
          }
          if (!this.repairs[i].cycle) {
            this.alertInfo.content = this.$t(
              "page.maintenance_period_cannot_empty"
            );
            checkList[3] = false;
            break;
          }
        }

        // if (!this.isRepeat(this.repairs.filter(item => !item.is_deleted), "item_name")) {
        //   this.alertInfo.content = this.$t('page.maintenance_item_name_must_unique');
        //   checkList[3] = false
        // }
        // 判断相同的维护保养名称是否有不同的维护周期
        if (
          this.repairs.some((item, index, arr) => {
            return (
              arr.findIndex(
                (other) =>
                  !other.is_deleted &&
                  other.name == item.name &&
                  other.cycle != item.cycle
              ) !== -1
            );
          })
        ) {
          this.alertInfo.content = this.$t(
            "page.maintenance_item_name_must_same_cycle"
          );
          checkList[3] = false;
        }
      }

      // 测量值定义表单检测

      if (attributes.measurements.length) {
        for (let i = 0; i < attributes.measurements.length; i++) {
          if (attributes.measurements[i].name) {
            if (attributes.measurements[i].name.length > 50) {
              this.alertInfo.content = this.$t(
                "page.MeasurementPointNameCannotExceed"
              );
              break;
            }
          } else {
            this.alertInfo.content = this.$t(
              "page.MeasurementPointNameCannotEmpty"
            );
            break;
          }

          if (!attributes.measurements[i].dtype) {
            this.alertInfo.content = this.$t(
              "page.MeasurementPointDataTypeCannotEmpty"
            );
            break;
          }

          if (attributes.measurements[i].unit.length > 50) {
            this.alertInfo.content = this.$t(
              "page.MeasurementPointUnitCannotExceed"
            );
            break;
          }

          if (i == attributes.measurements.length - 1) checkList[2] = true;
        }

        if (!this.isRepeat(attributes.measurements, "name")) {
          this.alertInfo.content = this.$t(
            "page.MeasurementPointNameCannotRepeated"
          );
          checkList[2] = this.isRepeat(attributes.measurements, "name");
        }
      } else {
        checkList[2] = true;
      }

      // 属性定义表单检测
      if (attrData) {
        let result = [false, false];
        if (!this.isRepeat(attributes.attributes, "group")) {
          this.alertInfo.content = this.$t(
            "page.GroupNameCannotBeRepeatedInThePropertyDefinition"
          );
          checkList[1] = this.isRepeat(attributes.attributes, "group");
        } else {
          for (let i = 0; i < attributes.attributes.length; i++) {
            if (!this.isRepeat(attributes.attributes[i].list, "name")) {
              this.alertInfo.content = this.$t(
                "page.AttributeNamesInTheSameGroupOfAttributesCannotBeTheSameInTheAttributeDefinition"
              );
              checkList[1] = false;
              break;
            } else if (i == attributes.attributes.length - 1) {
              result[1] = true;
            }
          }
        }

        for (let i = 0; i < attrData.length; i++) {
          if (attrData[i].group) {
            if (attrData[i].group.length > 50) {
              this.alertInfo.content = this.$t(
                "page.AttributeDefinitionGroupNameCannotExceed"
              );
              checkList[1] = false;
              break;
            }
          } else {
            this.alertInfo.content = this.$t(
              "page.AttributeDefinitionGroupNameCannotEmpty"
            );
            checkList[1] = false;
            break;
          }

          if (attrData[i].name) {
            if (attrData[i].name.length > 50) {
              this.alertInfo.content = this.$t(
                "page.AttributeDefinitionNameCannotExceed"
              );
              checkList[1] = false;
              break;
            }
          } else {
            this.alertInfo.content = this.$t(
              "page.AttributeDefinitionNameCannotEmpty"
            );
            checkList[1] = false;
            break;
          }

          if (!attrData[i].dtype) {
            this.alertInfo.content = this.$t(
              "page.AttributeDefinitionDataTypeCannotEmpty"
            );
            checkList[1] = false;
            break;
          }

          if (String(attrData[i].default).length > 50) {
            this.alertInfo.content = this.$t(
              "page.AttributeDefinitionDefaulteLengthCannotExceed"
            );
            checkList[1] = false;
            break;
          }

          if (i == attrData.length - 1) {
            result[0] = true;
          }
        }
        checkList[1] = result[0] && result[1];

        this.attributes.map((Item) => {
          Item.list.map((item) => {
            item["dataValidation"] = {
              type: false,
              typeError: "",
            };

            if (item.dtype == "float" && item.default != "") {
              if (
                !(
                  this.isNumber(item.default) &&
                  /^(-?\d+)(\.\d+)?$/.test(Number(item.default))
                )
              ) {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.value_must_double_precision_number"),
                };
                checkList[1] = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_double_default_value_fail"
                );
              }
            }

            if (item.dtype == "number" && item.default != "") {
              if (
                !(
                  this.isNumber(item.default) &&
                  /^-?\d+$/.test(Number(item.default))
                )
              ) {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.must_be_integer"),
                };
                checkList[1] = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_integer_default_value_fail"
                );
              }
            }

            if (item.dtype == "boolean" && item.default != "") {
              item.default = item.default.toString();
              if (item.default != "false" && item.default != "true") {
                item["dataValidation"] = {
                  type: true,
                  typeError: this.$t("page.input_true_or_false"),
                };
                checkList[1] = false;
                this.alertInfo.content = this.$t(
                  "page.data_type_bool_default_value_fail"
                );
              }
            }
          });
        });
      }

      // 父类产品校验
      if (!parentInfo.node.length) {
        this.alertInfo.content = this.$t("page.ParentProductCannotBeEmpty");
        return;
      }

      // 基本信息表单检测
      if (baseInfo.name) {
        if (baseInfo.name.length <= 50) {
          checkList[0] = true;
        } else {
          this.alertInfo.content = this.$t(
            "page.BasicInformationNameLengthCannotExceed"
          );
        }
      } else {
        this.alertInfo.content = this.$t(
          "page.BasicInformationNameCannotEmpty"
        );
      }

      checkResult = checkList.every((item) => {
        return item;
      });
      this.fault_knowledge.map(item=>{
          if(item.name.length==0){
              item.nameType=true
              checkResult=false
          }
             })
      return checkResult;
    },
    /* 处理最终提交的数据params */
    handleFilterSubmitData() {
      let tmpData = _.cloneDeep({
        baseInfo: this.baseInfo,
        attributes: {
          attributes: this.attributes,
          measurements: this.measurements,
        },
        repairs: this.repairs,
        tags: this.tags,
      });

      if (tmpData.tags.length) {
        tmpData.tags = tmpData.tags.filter((item) => {
          return item.key || item.value;
        });
      }

      console.log(tmpData);
      if (_.get(tmpData, ["attributes", "attributes"]).length) {
        let result = [];
        _.get(tmpData, ["attributes", "attributes"]).forEach((Item) => {
          var group = Item.group;
          Item.list.forEach((item) => {
            // if (this.$route.query.title == "新建产品") {
            //   item["owner"] = "inherit";
            // }
            if (item.dtype == "number" || item.dtype == "float") {
              item.default = Number(item.default);
            }
            if (item.dtype == "boolean") {
              if (item.default == "false") {
                item.default = false;
              } else if (item.default == "true") {
                item.default = true;
              }
            }
            if (!item.unit) {
              item.unit = this.$t("page.no");
            }
            item.updateTime = moment().format("YYYY-MM-DD HH:mm:ss");
            result.push({ ...item, group });
          });
        });
        tmpData.attributes.attributes = result;
      }
      //   if (_.get(tmpData, ["attributes", "measurements"]).length) {
      //     _.get(tmpData, ["attributes", "measurements"]).forEach((Item) => {
      //       if (this.$route.query.title == "新建产品") {
      //         Item["owner"] = "inherit";
      //       }
      //     });
      //   }
      console.log(_.get(tmpData, ["attributes"], {}));


      let params = {
        name: _.get(tmpData, ["baseInfo", "name"], ""),
        description: _.get(tmpData, ["baseInfo", "description"], ""),
        attributes: JSON.stringify(_.get(tmpData, ["attributes"], {})),
        tags: JSON.stringify(_.get(tmpData, ["tags"], [])),
        repairs: JSON.stringify(_.get(tmpData, ["repairs"], [])),
        files: JSON.stringify(this.files),
        parent_id: this.parentInfo.node[this.parentInfo.node.length - 1],
        product_type: this.parentInfo.type,
        customer_id: this.customer_id,
        service_company_id: this.service_company_id,
        fault_knowledge: JSON.stringify(this.fault_knowledge),
        extra_info: JSON.stringify({
          color: randomColor(),
        }),
        is_import_pump: _.get(tmpData, ["baseInfo", "is_import_pump"], false),
        is_iot_ready: _.get(tmpData, ["baseInfo", "is_iot_ready"], false),
      };
      return params;
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "5000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
  },
};
</script>
